import { DEFAULT_API_CONFIG } from './apiConfig';
import queryString from 'query-string';

const { url, getHeaders } = DEFAULT_API_CONFIG;
const baseRoute = `${url}/questions`;

// TODO.deprecate these
export const getAllQuestions = async () => {
  const url = baseRoute;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

export const getQuestion = async id => {
  const url = `${baseRoute}/${id}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  return response.ok ? await response.json() : Promise.reject(response);
};

// TODO: rename this.  This updates the full form header
export const updateQuestion = async q => {
  const url = `${baseRoute}/${q.id}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'PUT',
    body: JSON.stringify(q),
    headers,
  });
  return response.ok ? response : Promise.reject(response);
};

// this updates the answer values for a specific question
export const updateAnswerWeight = async q => {
  const url = `${baseRoute}/question/${q.questionId}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'PUT',
    body: JSON.stringify(q),
    headers,
  });
  return response.ok ? response : Promise.reject(response);
};

// TODO.replace the above with these
export const getHazardScores = async () => {
  const url = `${baseRoute}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const getHazardScoreById = async (formHeaderId, clientId) => {
  const q = queryString.stringify({
    clientId,
  });
  const url = `${baseRoute}/${formHeaderId}?${q}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const updateHazardScore = async (question, clientId) => {
  const q = queryString.stringify({
    clientId,
  });
  const url = `${baseRoute}/${question.id}?${q}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'PUT',
    body: JSON.stringify(question),
    headers,
  });

  return response.ok ? await response.json() : Promise.reject(response);
};
